export default function Footer() {
  return (
    <footer className="mt-auto border-t border-gray-200 bg-white py-4">
      <div className="container mx-auto px-4 text-center text-sm text-gray-500">
        AP Course Improvement v1.0, Copyright(C) 2025, Ryan's Workshop
      </div>
    </footer>
  );
}
